import React from 'react';
import BannerSection from '../components/BannerSection';
import About from '../components/About';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import ContactUs from '../components/ContactUs';

const Home = () => {
  return (
    <>
    <BannerSection/>
      <About />
      <ServicesSection />
      <WhyChooseUs />
      <Testimonials />
      <ContactUs />
    </>
  );
};

export default Home;